import styles from "./Evaluaciones.module.css";

export function ResumenEvaluacion({ items, className = "" }) {
  return (
    <div className={`${styles.summary} ${className}`}>
      {items.map(([label, value]) => (
        <div key={label}>
          <span>{label}</span>
          <strong>{value}</strong>
        </div>
      ))}
    </div>
  );
}
